import type { PartnerAddress } from "@stockline/shared/types/crm/partner-address"
import type { OfflineResourceConfig } from "../../../types"
import { PARTNER_ADDRESS_TABLE } from "./db"

export const partnerAddressConfig: OfflineResourceConfig<PartnerAddress> = {
  name: "partner-addresses",
  // Catalogue-bound tenants pull all partner addresses as `reference` on cold
  // start. 3000/page cuts the request count on large tenants (~576KB→~1.7MB
  // decoded per page, under the API's served ceiling); small tenants stay 1
  // page. STK-1960.
  pageSize: 3000,
  endpoints: {
    full: "/api/v2/partner-addresses",
    delta: "/api/v2/partner-addresses/changes",
    push: "/api/v2/partner-addresses/changes",
  },
  tableName: PARTNER_ADDRESS_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    partnerId: "partnerId",
    isDefault: "isDefault",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
